<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper" :class="[alignMiddle === true ? 'alignMiddle' : 'alignTop']">
                <div class="modal-container" :style="{width, height}">
                    <div v-if="title !== null" class="modal-header">
                        <div class="modal-header-text">{{ title }}</div>
                        <div class="modal-header-close" @click="$emit('close')">
                            <fa icon="xmark"></fa>
                        </div>
                    </div>
                    <div v-else-if="$slots.header">
                        <slot name="header"></slot>
                        <fa v-if="hideClose === false" :icon="['fal', 'times']"
                            class="closeIcon pull-right float-right is-pulled-right" size="lg" title="Close"
                            ></fa>
                    </div>

                    <div class="modal-body" :style="{height: bodyHeight}">
                        <slot></slot>
                        <slot name="body"></slot>
                    </div>

                    <div class="modal-footer">
                        <slot name="footer">
                            <button class="btn btn-default pull-right button is-pulled-right" @click="$emit('close')">
                                Close
                            </button>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script type="text/javascript">
  export default {
    props: {
      title: {
        type: String,
        default: null
      },
      width: {
        type: String,
        default: '60vw'
      },
      height: {
        type: String,
        default: null
      },
      footerHeight: {
        type: String,
        default: '0'
      },
      hideClose: {
        type: Boolean,
        default: false
      },
      alignMiddle: {
        type: Boolean,
        default: false
      },
      moveToBody: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      bodyHeight() {
        let percentage = this.$slots.header ? '90%' : '100%';
        return this.footerHeight > 0 ? `calc(${percentage} - ${this.footerHeight})` : percentage;
      }
    },
    mounted() {
      if (this.moveToBody === true) {
        document.body.prepend(this.$el);
      }
    }
  };
</script>
<style lang="scss">
$color-combo-1-background: $primary-lighter-20;
$color-combo-1-color: $primary-font-color;

    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;
    }

    .modal-mask .modal-wrapper {
        display: table-cell;
    }

    .modal-mask .modal-wrapper.alignTop .modal-container {
        margin-top: 20px;
    }

    .modal-mask .modal-wrapper.alignMiddle {
        vertical-align: middle;
    }

    .modal-mask .modal-container {
        width: 300px;
        margin: 0px auto;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
    }

    .modal-mask .modal-header {
        height: 40px;
        display: flex;
        align-items: center;
        background-color:$color-combo-1-background;
        color: $color-combo-1-color;
    }

    .modal-mask .modal-header .modal-header-text {
        text-align: center;
        font-weight: 700;
        flex: 1;
        user-select: none;
    }

    .modal-mask .modal-header .modal-header-close {
        padding-right: 15px;
        font-size: 1.2em;
        cursor: pointer;
        color: $color-combo-1-color;
    }

    .modal-mask .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-mask .modal-body {
        height: 100%;
        padding: 0;
    }

    .modal-mask .modal-footer {
        padding: 0;
        border: 0;
        height: 10%;
    }

    .modal-mask .modal-enter {
        opacity: 0;
    }

    .modal-mask .modal-leave-active {
        opacity: 0;
    }

    .modal-mask .closeIcon {
        cursor: pointer;
        position: relative;
        transition: opacity .25s ease-in-out;
        z-index: 1;
    }

    .modal-mask .closeIcon:hover {
        opacity: 0.6;
    }

    .modal-mask .modal-enter .modal-container,
    .modal-mask .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }
</style>